import { useAuth0 } from '@auth0/auth0-react'
import { navigate } from 'gatsby'
import { useCustomerQuery } from 'lib/graphql/storefront'
import { useLayoutEffect } from 'react'
import store from 'store/store'

const useLoginRedirect = () => {
  const { user } = useAuth0()
  const { data: customerData } = useCustomerQuery()
  const { auth } = store.getState()

  useLayoutEffect(() => {
    // loginしていない場合は toppage へ redirect する
    if (!auth?.accessToken) navigate('/', { replace: true })
    // loginした後、検証されてない・addressがない場合のロジックは　SessionCheck コンポーネントで処理する
    // loginした後、検証済み・addressもある場合は　toppage へ redirect する
    if (
      auth?.accessToken &&
      user?.email_verified &&
      customerData?.customer?.address
    ) {
      navigate('/', { replace: true })
    }
  }, [auth?.accessToken, user?.email_verified, customerData?.customer?.address])
}

export default useLoginRedirect
